import { Component, Input,    OnInit} from '@angular/core';
import { AbstractControl,  NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import  {SharedDataService} from '../../all-services';
import  {PS_Search_Suppliers_Result} from '../../all-models';
import {PafLabelDirective } from '../../all-directives';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';


@Component({
  selector: 'validation-errors',
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.component.scss']
})
export class ValidationErrorsComponent implements OnInit {

  @Input() controlName : string = null;
  @Input() form: NgForm = null;


  public pafLabels: PafLabelDirective = null;
  constructor(private route:ActivatedRoute,public sharedDatasSvc:SharedDataService) { }

  get control():AbstractControl{
    return this.form && this.controlName ? this.form.controls[this.controlName]: null;
  }


  public getDebugErrors():any[]{
    if (!this.control || !this.control.errors) return [];
    return Object.keys(this.control.errors).map(k=>this.control.errors[k]);
  }
  public getDisplayError(key:string): Observable<string>{
    let obsRet:Observable<string>;
    let replace1:string = '';
    let replace2:string = '';
    let error: any = this.control.errors[key];
    if (!error) return of('');
    if (['minlength','maxlength'].indexOf(key.toLowerCase())>=0){
      obsRet=this.pafLabels.getLabel('taille_requise_actuelle');
      replace1=error.requiredLength;
      replace2=error.actualLength;
    } else if (key=='mask'){
      obsRet=this.pafLabels.getLabel('masque_requis');
      replace1=error.requiredMask;
    } else if (key=='email'){
      obsRet=this.pafLabels.getLabel('Format_email_incorrect');
    } else if (key=='siretUnique'){
      obsRet=this.pafLabels.getLabel('Siret_deja_reference_pour_le_fournisseur');
      replace1=(<PS_Search_Suppliers_Result>error).SupplierName;
    } else if (['emailUnique'].indexOf(key)>=0){
      obsRet=of(error.toString());
    } else if (['intraTvaUnique'].indexOf(key)>=0){
      obsRet= this.pafLabels.getLabel('IntraTva_deja_reference_pour_le_fournisseur');      
      replace1=(<PS_Search_Suppliers_Result>error).SupplierName;
    } else if (['rsaUnique'].indexOf(key)>=0){
      obsRet= this.pafLabels.getLabel('Rsa_deja_reference_pour_le_fournisseur');      
      replace1=(<PS_Search_Suppliers_Result>error).SupplierName;
    } else if (['siretSiegeWarning','siretSiegeError','ErreurSiret'].indexOf(key)>=0){
      obsRet= of(error.Message);
    } else if (this.pafLabels.labels.find(r=>r.LblCod==key)){
      obsRet= this.pafLabels.getLabel(key);
    } else if (typeof error === 'string' &&  this.pafLabels.labels.find(r=>r.LblCod==<string>error)){
      obsRet= this.pafLabels.getLabel(<string>error);
    } else {
      obsRet= of(this.control.errors[key]);
    }
    return obsRet.pipe(map((msg:string)=>{
      if (replace1) msg=msg.replace('&1',replace1);
      if (replace2) msg=msg.replace('&2',replace2);
      return msg;
    }));
  }

  warningKeys:string[]=['emailUnique','intraTvaWarning', 'siretSiegeWarning'];
  ngTextClass(key:string):any{
    return {
      'text-danger': this.warningKeys.indexOf(key)<0,
      'text-warning': this.warningKeys.indexOf(key)>=0,
    }
  }
  
  ngClassIcon(key:string):any{
    return {
       'fas fa-exclamation-triangle': this.warningKeys.indexOf(key)>=0,
    }
  }

  ngOnInit(): void {
    this.pafLabels=new PafLabelDirective(this.sharedDatasSvc,this.route,null);
    this.pafLabels.reloadLibs();
  }
}

